import { Alert, Stack } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useGetProjectQuery } from "../../../../../projectRTK";
import ConnectedTasksAndIssuesMiniTable from "../../MiniTables/ConnectedTasksAndIssuesMiniTable";
import TaskMiniTable from "../../MiniTables/TaskMiniTable";
import { IIssueModalSectionProps } from "./IssueItemModalMantine";

const IssueModalActions = ({ issueBoard, issue, projectId }: IIssueModalSectionProps) => {
  const { data: project, isLoading: projectLoading, error, isError } = useGetProjectQuery(projectId);

  if (isError) {
    return <div>Feil ved lasting av prosjektdata</div>;
  }

  return (
    <Stack gap="md" w="100%">
      {projectLoading !== true && (
        <>
          {isError === true ? (
            <Alert variant="light" color="red" title="Alert title" icon={<IconInfoCircle />}>
              Feil ved lasting av prosjektdata: {error?.toString()}
            </Alert>
          ) : (
            <TaskMiniTable
              fullWidth
              issueId={issue._id}
              issueBoardId={issueBoard._id}
              projectId={projectId}
              members={project?.members}
              issueLocalId={issue.id}
              issueBoard={issueBoard}
            />
          )}

          <ConnectedTasksAndIssuesMiniTable
            fullWidth
            issue={issue}
            issueId={issue._id}
            issueBoardId={issueBoard._id}
            projectId={projectId}
            issueBoard={issueBoard}
          />
        </>
      )}
    </Stack>
  );
};

export default IssueModalActions;
